import React from 'react'
import { css } from '@emotion/core'
import { HeaderBlock, SubheaderBlock } from '@fs/zion-ui'
import maleTwigs from './maleTwigs.svg'
import femaleTwigs from './femaleTwigs.svg'
import FSLogo from '../../../../../shared/assets/fs-logo.svg'
import maleIcon from '../../../../../shared/assets/male.svg'
import femaleIcon from '../../../../../shared/assets/female.svg'

export default function RelativeTakeaway({ heading, subHeading, relation, gender, profile }) {
  const splash = gender === 'male' ? maleTwigs : femaleTwigs
  const borderColor = gender === 'male' ? '#3FCDE3' : '#DD2762'

  if (!profile) {
    profile = gender === 'male' ? maleIcon : femaleIcon
  }

  const takeawayCss = css`
    width: 100%;
    box-sizing: border-box;
    border: 16px solid ${borderColor};
    background: white;
    position: relative;
  `

  const splashCss = css`
    width: 100%;
  `

  const headerCss = css`
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div > div {
      color: ${borderColor};
    }
  `

  const profileCss = css`
    position: absolute;
    top: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    > img {
      border: 10px solid ${borderColor};
      width: 320px;
      height: 320px;
      border-radius: 50%;
    }
  `

  const logoCss = css`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 100px;
    padding-bottom: 40px;
    > img {
      width: 160px;
    }
  `

  return (
    <div css={takeawayCss}>
      <img alt="Splash" crossOrigin="anonymous" src={splash} css={splashCss} />
      <div css={profileCss}>
        <img alt="profile" crossOrigin="anonymous" src={profile} />
      </div>
      <div css={headerCss}>
        <SubheaderBlock centered heading={relation} size="sm" />
      </div>
      <HeaderBlock centered size="lg" heading={heading} subHeading={subHeading} />
      <div css={logoCss}>
        <img alt="Logo" src={FSLogo} />
      </div>
    </div>
  )
}
